import React from 'react'

function Solana({ fill = '#A288DF' }) {
    return (
        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.96973 15.9172H19.1621L17.0469 18.0325C17.0433 18.036 17.0373 18.0393 17.0303 18.0393H4.83691L6.95312 15.9241C6.95668 15.9205 6.96264 15.9172 6.96973 15.9172Z" fill={fill} stroke={fill}/>
        <path d="M6.96973 6.5001L19.1621 6.5001L17.0469 8.61534C17.0433 8.61888 17.0373 8.62217 17.0303 8.62217H4.83691L6.94727 6.51182C6.95284 6.50683 6.95853 6.50389 6.96289 6.50206C6.96724 6.50025 6.96973 6.5001 6.96973 6.5001Z" fill={fill} stroke={fill}/>
        <path d="M17.0303 11.1784C17.0374 11.1784 17.0433 11.1817 17.0469 11.1853L19.1631 13.3005H6.96973C6.96266 13.3005 6.95668 13.2972 6.95312 13.2937L4.83789 11.1784H17.0303Z" fill={fill} stroke={fill}/>
        </svg>
    )
}

export default Solana